<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      ref="searchBox"
      @sub="sub"
      title="筛选"
      permpisionsQuery
    >
      <div slot="waitDeal" slot-scope="prop">
        <el-checkbox label="待我处理" name="type" v-model="prop.form.waitDeal" />
      </div>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
// import {
// } from 'api/cost';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        stateOptions: [], // 状态
        form: [
          { // 待我处理
            label: '',
            value: 'waitDeal',
            default: !this.$route.query.busiCode,
            slot: true,
            class: 'next-search-btn',
          },
          {
            label: '',
            value: 'state',
            type: 'radio',
            default: -1,
            class: 'especial-radio-group',
            normalFormNotCount: true,
            onChangeRadio: () => {
              this.$refs.searchBox.sub();
            },
          },
          { // 申请时间
            label: '申请时间',
            value: 'Time',
            type: 'date',
            default: [],
            placeholder: '请选择申请时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 申请人
            label: '申请人',
            value: 'applyUserName',
            type: 'input',
            placeholder: '请输入申请人',
          },
          { // 服务商
            label: '服务商',
            value: 'serviceName',
            type: 'input',
            placeholder: '请输入服务商',
          },
          { // 申请金额
            label: '申请金额',
            value: 'Amt',
            type: 'inputrange',
            default: [],
            placeholder: '请输入申请金额',
            attr: {
              type: 'daterange',
            },
          },
          // { // 申请单号
          //   label: '申请单号',
          //   value: 'busiCode',
          //   type: 'input',
          //   placeholder: '请输入申请单号',
          //   disabled: false,
          // },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 申请时间
      if (searchBoxData.Time && searchBoxData.Time[0]) {
        searchBoxData.applyTimeBegin = this.formatDate(searchBoxData.Time[0], 1);
        searchBoxData.applyTimeEnd = this.formatDate(searchBoxData.Time[1], 1);
      }
      delete searchBoxData.Time;
      // 申请金额
      if (searchBoxData.Amt && searchBoxData.Amt[0]) {
        searchBoxData.payAmtBegin = searchBoxData.Amt[0];
      }
      if (searchBoxData.Amt && searchBoxData.Amt[1]) {
        searchBoxData.payAmtEnd = searchBoxData.Amt[1];
      }
      delete searchBoxData.Amt;

      const busiCode = this.$route.query.busiCode;
      if (busiCode) {
        this.$refs.searchBox.setVal('busiCode', busiCode);
        searchBoxData.busiCode = busiCode;
      }

      searchBoxData.vehicleFeeType = 3;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
    // 从其他页面跳转过来
    jumpHereFromAnotherPage () {
      this.setFormAttrVal({
        form: this.searchBoxData,
        attr: 'disabled',
        value: !!this.$route.query.busiCode,
        names: ['busiCode'],
      });
    },

    jumpHereSearchState () {
      if (this.$route.query.state) {
        this.$refs.searchBox.setVal('state', this.$route.query.state);
      } else {
        this.$refs.searchBox.setVal('state', -1);
      }
    },

  },
  watch: {
    '$route.query.busiCode': function () {
      this.jumpHereFromAnotherPage();
    },
    '$route.query.state': function () {
      this.jumpHereSearchState();
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'VEHICLE_APPLY_STATE',
    });
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.jumpHereFromAnotherPage();
    this.jumpHereSearchState();
  },
  activated () {
    // 第一次进入
    const state = this.$route.query.state;
    if (state) {
      this.$refs.searchBox.setVal('state', state);
    }

    const waitDeal = this.$route.query.waitDeal;
    if (waitDeal) {
      this.$refs.searchBox.setVal('waitDeal', true);
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .next-search-btn {
  position: absolute;
  left: calc(100% - 315px);
  top: 110px;
  width: 100px !important;
}
</style>
